import { apiGet, apiPost, apiPut, apiRequest } from '@/utils/request';

interface DetailParams extends Record<string, unknown> {
  account_id: number;
  name: string;
}

interface CreateItem {
  source: string;
  account_id: number;
  name: string;
  send_conf?: Record<string, unknown>;
}

interface UpdateItem {
  id: number;
  name?: string;
  send_conf?: Record<string, unknown>;
}

export const materialSendConfsApi = {
  list: () => apiGet('/material-send-confs'),
  detail: (params: DetailParams) => apiGet('/material-send-confs/detail', params),
  batchCreate: (items: CreateItem[]) => apiPost('/material-send-confs', { items }),
  batchUpdate: (items: UpdateItem[]) => apiPut('/material-send-confs', { items }),
  removeByName: (name: string) =>
    apiRequest(`/material-send-confs/by-name?name=${encodeURIComponent(name)}`, {
      method: 'DELETE',
    }),
  renameByName: (old_name: string, new_name: string) =>
    apiPut('/material-send-confs/rename-by-name', { old_name, new_name }),
};
